
import ListV3 from './components/ListV3';

export default {
  i18nComponentKey: 'WidgetReviewsListV3.WidgetReviewsListV3Pc',
  name: 'WidgetReviewsListV3Pc',
  components: { ListV3 }
};
